export const Debug = {
    cms: {
        autoDump: false,
        run: true,
    },
};
